var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7943 0.640742C11.5748 -0.140897 12.8406 -0.141376 13.6217 0.639672L16.1135 3.13153C16.8879 3.90591 16.896 5.15956 16.1316 5.94383L14.4717 7.64692L9.13116 2.30643L10.7943 0.640742ZM8.07131 3.36789L13.4246 8.72119L6.89844 15.4171C6.33401 15.9962 5.55989 16.3227 4.75154 16.3227L1.99939 16.3226C1.14656 16.3225 0.465487 15.6116 0.501354 14.7589L0.619509 11.9499C0.651106 11.1986 0.963331 10.4866 1.4944 9.95476L8.07131 3.36789ZM17.2649 16.9999C17.679 16.9999 18.0146 16.664 18.0146 16.2496C18.0146 15.8352 17.679 15.4993 17.2649 15.4993H11.1432C10.7292 15.4993 10.3935 15.8352 10.3935 16.2496C10.3935 16.664 10.7292 16.9999 11.1432 16.9999H17.2649Z",
    fill: "#2B3F6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIc);
export default __webpack_public_path__ + "static/media/editIc.2a29a421ac85643fac34446c33f17e24.svg";
export { ForwardRef as ReactComponent };